__turbopack_context__.v({
  "releaseBadge": "release-status-badge-module-scss-module__lT0ixW__releaseBadge",
  "releaseBadgeText": "release-status-badge-module-scss-module__lT0ixW__releaseBadgeText",
});
